import Hero from '@/components/Hero';
import ScrollReveal from '@/components/ScrollReveal';
import { useLanguage } from '@/lib/i18n';
import { Zap, MessageCircle, SlidersHorizontal, Music } from 'lucide-react';
import SpotifyEmbed from '@/components/SpotifyEmbed';
import SelectedWorksTeaser from '@/components/SelectedWorksTeaser';

const features = [
  { key: 'sound', icon: Zap, accent: '#7F00FF' },
  { key: 'comm', icon: MessageCircle, accent: '#00E5FF' },
  { key: 'mix', icon: SlidersHorizontal, accent: '#7F00FF' },
];

export default function Home() {
  const { t } = useLanguage();

  return (
    <main id="main-content" data-testid="home-page">
      <Hero />

      <SelectedWorksTeaser />

      <div className="max-w-3xl mx-auto px-6 md:px-12 mb-16">
        <ScrollReveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#1DB954]/60 mb-4">SPOTIFY PLAYLIST</p>
          <h1 className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4" data-testid="playlist-page-title">
            {t('playlist_title')}
          </h1>
          <p className="text-white/35 text-md mb-8" data-testid="playlist-page-subtitle">
            {t('playlist_subtitle')}
          </p>
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <SpotifyEmbed />
        </ScrollReveal>
      </div>

    </main>
  );
}
